import * as React from "react"
import * as ReactDOM from "react-dom"
import * as Immutable from 'immutable'
import { default as Select, ReactSelectProps } from 'react-select';
import * as moment from 'moment';
import 'whatwg-fetch';

import { StartEnd, PrefixProps } from '../../utils/period_picker/PeriodPicker'
import RoomPeriodPicker from '../../utils/period_picker/RoomPeriodPicker'

import { Room } from '../../types/types'

import RoomSelector from './RoomSelector'
import { FocusedInputShape } from 'react-dates';

type RoomPickerProps = StartEnd & PrefixProps & {
  rooms: Room[],
  room: number
  source: string
  onRoomChange: (room: number) => void
  onDatesChange: (range: StartEnd) => void
  focusedInput: FocusedInputShape
  onFocusChange: (fi: FocusedInputShape) => void
  numberOfMonths?: number
  close: () => void
}

type RoomPickerState = {}

export default class BnbPeriodPicker extends React.Component<RoomPickerProps, RoomPickerState> {

  constructor(props, context) {
    super(props, context)
  }

  render() {
    const pickerProps = {
      prefix: 'sidebar',
      startDate: this.props.startDate,
      endDate: this.props.endDate
    }

    return (
      <div>
        <RoomSelector
          room={this.props.room}
          rooms={this.props.rooms}
          source={this.props.source}
          onRoomChange={(value: number) => this.props.onRoomChange(value)}
        />
        <RoomPeriodPicker
          {...pickerProps}
          close={() => this.props.close()}
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          room_id={this.props.room}
          prefix={this.props.prefix}
          onDatesChange={(range: StartEnd) => this.props.onDatesChange(range)}
          onFocusChange={this.props.onFocusChange}
          focusedInput={this.props.focusedInput}
          numberOfMonths={this.props.numberOfMonths}
        />
      </div>
    )
  }
}